<template>
    <time v-if="post.date" :datetime="post.date" :class="post.updated ? 'time updated-time' : 'time'">
        <a v-if="post.updated" href @click.stop.prevent="linkDateClick">Обновлён: {{post.date}}</a>
        <span v-else>{{post.date}}</span>
    </time>
</template>

<script>
    import {mapMutations, mapActions} from 'vuex'
    import PostVersionsComponent from "./PostVersions";

    export default {
        name: 'post-date',
        props: ['post'],
        methods: {
            ...mapActions([
                'switchPopup'
            ]),
            ...mapMutations([
                'setPopupComponent',
            ]),
            ...mapMutations('knowledge',[
                'setVersions'
            ]),
            linkDateClick() {
                this.setPopupComponent(PostVersionsComponent);
                this.setVersions(this.post.versions);
                this.switchPopup(true);
            }
        },
    }
</script>


<style scoped>

</style>
